import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from '@xstyled/styled-components';
import { getColor, getSize } from '@lib/common';
export var AnswerSectionTitle = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 500;\n  line-height: 1rem;\n  color: ", ";\n  text-transform: uppercase;\n"])), getSize('typo12'), getColor('contentMinimum'));